<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-plane"></i><strong> Lista Inspecion</strong>
                <div class="card-header-actions">
                  <small class="text-muted">-</small>
                </div>
              </div>
              <plano ref="plano" :plain_file="plain_file"></plano>
              <h1>Inspecciones</h1>
              <div align="right"></div>
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :fields="json_fields2"
                    worksheet="Stock"
                    :name="name"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                  >
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div>

                <template slot="afterFilter">
                  <tr v-if="loading" class="VueTables__no-results">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      class="ml-2 mt-1"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </tr>
                </template>

                <template slot="shipment_status" slot-scope="props">
                  <div style="text-align: center">
                    <b-badge
                      pill
                      :variant="getBadge(props.row.shipment_status)"
                      >{{ status(props.row.shipment_status) }}</b-badge
                    >
                  </div>
                </template>

                <div class="text-right" slot="actions" slot-scope="props">
                  <!--  <a target="_blank" href="#" @click.prevent="showBoardinInstructiveModal(props.row)" class="fa fa-lg fa fa-file-pdf-o text-primary" title="Instructivo Embarque"></a>&nbsp;
            <a target="_blank" href="#" @click.prevent="showExportInvoiceModal(props.row)" class="fa fa-lg fa fa-file-text text-primary" title="Factura de Exportación"></a>&nbsp;
            <a target="_blank" href="#" @click.prevent="editShipment(props.row)" class="fa fa-lg fa-edit text-primary"></a>&nbsp; -->
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="
                      downloadWithAxios(
                        'Packing List',
                        props.row.sif_number,
                        `/api/comex/inspection/${props.row.id}/packing_list/`
                      )
                    "
                    class="fa fa-lg fa fa-list text-black-50"
                    title="Packing List"
                  ></a
                  >&nbsp;&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="
                      downloadWithAxios(
                        'SIF',
                        props.row.sif_number,
                        `/api/comex/inspection/${props.row.id}/download_sif_excel/`
                      )
                    "
                    class="fa fa-lg fa fa-table text-black-50"
                    title="SIF"
                  ></a
                  >&nbsp;&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="mostrarArchivoPlano(props.row.id)"
                    class="fa fa-lg fa-code text-black-50"
                    title="Archivo Plano"
                  ></a
                  >&nbsp;
                  <a
                    target="_blank"
                    href="#"
                    @click.prevent="approvePallet(props.row)"
                    class="fa fa-lg fa-check-square-o text-black-50"
                    title="Aprobar Pallet"
                  ></a
                  >&nbsp;

                  <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger"></a>-->
                </div>
              </v-server-table>

              <b-modal
                v-model="modalShownBordingInstructive"
                centered
                size="lg"
                title="Instructivos de embarque"
                hide-footer
              >
                <component
                  :is="componenteActual"
                  :idBording="idBording"
                  :shipment="shipment"
                  :ref="report"
                ></component>
              </b-modal>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import ReportInstructivoEmbarqueMaritimo from "./ReportInstructivoEmbarqueMaritimo.vue";
import ReportInstructivoEmbarqueAereo from "./ReportInstructivoEmbarqueAereo.vue";
import ReportFacturaExportacion from "./ReportFacturaExportacion.vue";
import Plano from "./Plano.vue";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";

window.axios = require("axios");

Vue.component("downloadExcel", JsonExcel);
Vue.use(ServerTable);

export default {
  name: "ListInspeccion",
  components: {
    ServerTable,
    Plano,
    ReportInstructivoEmbarqueMaritimo,
    ReportInstructivoEmbarqueAereo,
    ReportFacturaExportacion
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: ["BoardingID"],
  data() {
    return {
      loading: false,
      plain_file: {
        filename: "",
        header: "",
        pallets: {}
      },
      loading: false,
      modalShownBordingInstructive: false,
      idBording: 0,
      shipment: "",
      componenteActual: "",
      report: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        "Num Sif": "sif_number"
      },
      columns: [
        // 'id',
        "sif_number",
        "sif_date",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            /* results[key].waybill_date = moment(results[key].waybill_date).format('DD-MM-YYYY');
                    results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms)); */
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          id: "id",
          sif_number: "Numero SIF",
          sif_date: "Fecha SIF",
          inspection_list: "pallets",

          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        "Numero SIF": "sif_number",
        "Fecha SIF": "sif_date"
      }
    };
  },
  computed: {
    url() {
      return "/api/comex/inspection/detailed/";
    },
    name() {
      return (
        "ListInspeccion " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls"
      );
    }
  },
  methods: {
    async fetchData() {
      const response = await this.$axios.get("/api/comex/inspection/detailed/");

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    forceFileDownload(response, a, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        filename + " - Inspeccion SIF #" + a + ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(filename, b, url) {
      this.$axios({
        method: "get",
        url: url,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b, filename);
        })
        .catch(() => console.log("error occured"));
    },

    mostrarArchivoPlano(a) {
      this.$axios
        .get("/api/comex/inspection/" + a + "/plain_file/")
        .then((res) => {
          this.plain_file.filename = res.data.plain_file.filename;
          this.plain_file.header = res.data.plain_file.header;
          this.plain_file.pallets = res.data.plain_file.pallets;
        })
        .catch((error) => {
          this.plain_file.filename = "ERROR";
          this.plain_file.header = "ERROR";
          this.plain_file.pallets = "ERROR";
          console.log(error);
        });
      this.$refs.plano.showModal();
    },
    approvePallet(row) {
      //console.log(row.status);

      if (row.status == 1) {
        this.$swal.fire("Inspección de pallets ya fue realizada", "", "info");
      } else {
        this.$router.push("/exportacion/aprobar/" + row.id);
      }
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },
    showBoardinInstructiveModal(a) {
      //es maritimo
      if (a.shipment_type.id == 1) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueMaritimo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }

      //es aereo
      if (a.shipment_type.id == 2) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueAereo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }
    },
    showExportInvoiceModal(a) {
      this.modalShownBordingInstructive = true;
      this.idBording = a.id;
      this.shipment = a;
      this.componenteActual = "ReportFacturaExportacion";

      this.report = "report";
      this.$nextTick(function () {
        this.$refs.report.calcular();
      });
    },
    editShipment(a) {
      //console.log(a.id);
      this.$router.push("/exportacion/editar/" + a.id);
    },
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
